import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TWebsiteBuilderContainerType } from "../../nodes/container/websiteBuilderContainer";
import {
  faBrowsers,
  faBullhorn,
  faGrid2,
  faImage,
  faLayerGroup,
  faRectangle,
  faRectangleList,
  faTable,
} from "@fortawesome/pro-regular-svg-icons";
import { IWebsiteBuilderNodeMetadata } from "../nodeMetadata/websiteBuilderNodeMetadata";

type TWebsiteBuilderContainerMetadata = Record<TWebsiteBuilderContainerType, IWebsiteBuilderNodeMetadata>;

export function useWebsiteBuilderContainerMetadata(): TWebsiteBuilderContainerMetadata {
  const { t } = useTranslation();

  const containerMetadata: TWebsiteBuilderContainerMetadata = useMemo(() => ({
    "box": { title: t("Box"), icon: faRectangle },
    "flex": { title: t("Stack"), icon: faLayerGroup },
    "form": { title: t("Form"), icon: faRectangleList },
    "grid": { title: t("Grid"), icon: faGrid2 },
    "marquee": { title: t("Scrolling Banner"), icon: faBullhorn },
    "slideshow": { title: t("Slideshow"), icon: faImage },
    "table": { title: t("Table"), icon: faTable },
    "tabset": { title: t("Tabs"), icon: faBrowsers },
  }), []);

  return containerMetadata;
}